<script lang="ts">
  import { Forward, Reply, ReplyAll, href } from "../../../../utils/Constant/Constant";
  import { Button } from "sveltestrap";
</script>
<div class="emailread-group">
    <textarea class="form-control" rows="4" cols="50" placeholder="write about your nots"></textarea>
    <div class="action-wrapper">
        <ul class="actions">
            <li>
                <Button color="primary" href={href}><i class="fa fa-reply me-2"></i>{Reply}</Button>
            </li>
            <li>
                <Button color="secondary" href={href}><i class="fa fa-reply-all me-2"></i>{ReplyAll}</Button>
            </li>
            <li>
                <Button color="danger" href={href}><i class="fa fa-share me-2"></i>{Forward}</Button>
            </li>
        </ul>
    </div>
</div>